import "../../../../styles/workspace_styles/RootUserStyles/SystemAdministrators/SystemAdministrators.css";
import NavigationBar from "../../../navigation_components/NavigationBar";
import RootUserSideBar from "../../../sidebar_components/RootUserSideBar";
import NewSystemAdministrator from "./NewSystemAdministrator";
import { useContext, useEffect, useState } from "react";
import { SystemAdministratorContext } from "./SystemAdministratorProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import { AppContext } from "../../../AppProvider";
import DeleteSystemAdministrator from "./DeleteSystemAdministrator";
import EditSystemAdministrator from "./EditSystemAdministrator";

const SystemAdministratorsTable = () =>{
    const {
        systemAdministrators,
        setSelectedToEditSystemAdministrator,
        setSelectedToDeleteSystemAdministrator
    } = useContext(SystemAdministratorContext);
    if(!Array.isArray(systemAdministrators)) return null;
    return(
        <div className="root-user-system-administrators-table-container">
            <table>
                <thead>
                    <tr id="root-user-system-administrators-table-header-row">
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email Address</th>
                        <th>Created at</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {systemAdministrators && [...systemAdministrators].map((systemAdministrator) =>(
                        <tr key={systemAdministrator?.id}>
                            <td>{systemAdministrator?.firstName}</td>
                            <td>{systemAdministrator?.lastName}</td>
                            <td>{systemAdministrator?.emailAddress}</td>
                            <td>{systemAdministrator?.dateCreated}</td>
                            <td>
                                <img
                                    title="Edit system administrator"
                                    onClick={() => setSelectedToEditSystemAdministrator(systemAdministrator)}
                                    src={`${process.env.PUBLIC_URL}/images/edit-icon.png`}
                                />
                                <img
                                    title="Delete system administrator"
                                    onClick={() => setSelectedToDeleteSystemAdministrator(systemAdministrator)}
                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
const SystemAdministrators = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        showCreateNewSystemAdministratorWindow,
        setShowCreateNewSystemAdministratorWindow,
        systemAdministrators,setSystemAdministrators,
        reloadSystemAdministrators,setReloadSystemAdministrators,
        selectedToDeleteSystemAdministrator
    } = useContext(SystemAdministratorContext);
    const fetchSystemAdministrators = async() =>{
        try{
            const url = `${usersMicroserviceUrl}/root/system-admins`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setSystemAdministrators(await response.json());
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when retrieving system administrators',error);
        }
    };
    useEffect(() =>{
        document.title = 'Blink IOT | System administrators';
        fetchSystemAdministrators();
    },[]);
    useEffect(() =>{
        if(!reloadSystemAdministrators) return;
        const refetchSystemAdministrators = async() => {
            await fetchSystemAdministrators();
            setReloadSystemAdministrators(false);
        };
        refetchSystemAdministrators();
    },[reloadSystemAdministrators]);
    return(
        <div className="root-user-system-administrators-page">
            <NavigationBar/>
            <div className="root-user-system-administrators-page-layout">
                <div>
                    <RootUserSideBar/>
                </div>
                <div className="root-user-system-administrators-parent-container">
                        {!Array.isArray(systemAdministrators) && !showCreateNewSystemAdministratorWindow && !selectedToDeleteSystemAdministrator? 
                            (
                                <div className="root-user-system-administrators-container">
                                    <div className="root-user-system-administrators-header-container">
                                        <h2>System Administrators</h2>
                                    </div>
                                    <div className="root-user-loading-system-administrators-parent-container">
                                        <div className="root-user-loading-system-administrators-container">
                                            <div></div>
                                            <p>Loading System Administrators. Please wait...</p>
                                        </div>
                                    </div>
                                </div>
                            ):reloadSystemAdministrators && !showCreateNewSystemAdministratorWindow && !selectedToDeleteSystemAdministrator?
                            (
                                <div className="root-user-system-administrators-container">
                                    <div className="root-user-system-administrators-header-container">
                                        <h2>System Administrators</h2>
                                    </div>
                                    <div className="root-user-loading-system-administrators-parent-container">
                                        <div className="root-user-loading-system-administrators-container">
                                            <div></div>
                                            <p>Reloading System Administrators. Please wait...</p>
                                        </div>
                                    </div>
                                </div>
                            ):Array.isArray(systemAdministrators) && systemAdministrators.length === 0 && !selectedToDeleteSystemAdministrator?
                            (
                                <div className="root-user-system-administrators-unavailable-container"
                                    style={{display:showCreateNewSystemAdministratorWindow? 'none':'block'}}>
                                    <h2>No system administrators available</h2>
                                    <p>There are currently no system administrators to display.</p>
                                    <div>
                                        <button onClick={() => setShowCreateNewSystemAdministratorWindow(true)}>Create System Admin</button>
                                    </div>
                                </div>
                            ):Array.isArray(systemAdministrators) && systemAdministrators.length > 0?
                            (
                                <div className="root-user-system-administrators-container">
                                    <div className="root-user-system-administrators-header-container">
                                        <h2>System administrators</h2>
                                        <div className="root-user-system-administrators-header-controls">
                                            <button className="root-user-add-new-system-administrator-button"
                                                onClick={() => setShowCreateNewSystemAdministratorWindow(true)}>
                                                <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                            </button>
                                        </div>
                                    </div>
                                    <SystemAdministratorsTable/>
                                </div>
                            ):
                            (<></>)
                        }
                    </div>
                </div>
            <NewSystemAdministrator/>
            <EditSystemAdministrator/>
            <DeleteSystemAdministrator/>
        </div>
    );
};
export default SystemAdministrators;